module.exports = __webpack_public_path__ + "images/FUSA_icons/064-rating.34716a85f0d847be562a00a5e3f8d74b.svg";